import React from "react";

// components
import CardStats from "components/Cards/CardStats.js";

export default function HeaderStats({totalcredits, totalspent, lastbuy, lastspent, memstartdate, memexpiredate, remainingmapcodes, mapcodelastgen}) {  
  return (
    <>
      {/* Header */}
      <div className="relative">
        <div className="px-4 md:px-10 mx-auto w-full">
          <div>
            {/* Card stats */}
            <div className="flex flex-wrap">
                  <div className="lg:w-3/12 md:w-full sm:w-full xl:w-3/12 xs:w-full px-2">
                    <CardStats
                      statSubtitle="CREDITS"
                      statTitle={totalcredits.toString()}
                      statArrow="up"
                      statPercent={lastbuy==null?"No date":lastbuy.replace(/T/g," ").replace(/.000Z/g,"")}
                      statPercentColor="text-green-500"
                      statDescripiron="last buy"
                      statIconName="far fa-chart-bar"
                      statIconColor="bg-red-500"
                    />
                  </div>
                  <div className="lg:w-3/12 md:w-full sm:w-full xl:w-3/12 xs:w-full px-2">
                    <CardStats
                      statSubtitle="TOTAL SPEND"
                      statTitle={totalspent.toString()}
                      statArrow="down"
                      statPercent={lastspent==null?"No date":lastspent.replace(/T/g," ").replace(/.000Z/g,"")}
                      statPercentColor="text-red-500"
                      statDescripiron="last spend"
                      statIconName="fas fa-chart-pie"
                      statIconColor="bg-orange-500"
                    />
                  </div>
                  <div className="lg:w-3/12 md:w-full sm:w-full xl:w-3/12 xs:w-full px-2">
                    <CardStats
                      statSubtitle="MAP CODES"
                      statTitle={remainingmapcodes==null?0:remainingmapcodes.toString()}
                      statArrow="down"
                      statPercent={mapcodelastgen==null?"No date":mapcodelastgen.replace(/T/g," ").replace(/.000Z/g,"")}
                      statPercentColor="text-blue-500"
                      statDescripiron="last gen"
                      statIconName="fas fa-map-marker"
                      statIconColor="bg-blue-500"
                    />
                  </div>
                  <div className="lg:w-3/12 md:w-full sm:w-full xl:w-3/12 xs:w-full px-2">
                    <CardStats
                      statSubtitle="MEMBERSHIP"
                      statTitle={memexpiredate===""?"No membership":"Exp " + memexpiredate.replace(/T/g," ").replace(/.000Z/g,"")}
                      statArrow="calender"
                      statPercent={memstartdate===""?"No":memstartdate.replace(/T/g," ").replace(/.000Z/g,"")}
                      statPercentColor="text-green-500"
                      statDescripiron="start date"
                      statIconName="fas fa-calendar-alt"
                      statIconColor="bg-green-500"
                    />
                  </div>              
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
